export default __webpack_public_path__ + "static/media/postman.ca42acfe.png";